import React from 'react';
import styles from './PopupWrapper.module.sass';

export function PopupWrapper() {
    return (
        <div className={styles.popup_wrapper}></div>
    );
};